
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/media",
      function () {
        return require("private-next-pages/[athleteSlug]/media.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/media"])
      });
    }
  